import React from "react";
import calcs from "./calcs";
import "./App.css";

function App() {
  const [input, setInput] = React.useState("");

  const currentAddress = calcs.results[input.toLowerCase()];
  return (
    <div className="App">
      <header className="App-header">
        <h4>Approximate snoozer compensations</h4>
        <label for="search">Search</label>
        <input
          type="text"
          value={input}
          placeholder="Enter eth address"
          onChange={(e) => setInput(e.target.value)}
        />
        {currentAddress ? (
          <div className="list">
            <div className="address">
              <a
                href={`https://etherscan.io/address/${currentAddress.address}`}
              >
                {currentAddress.address}
              </a>
            </div>
            <div className="unilost">
              <b>UNI STAKED: </b>
              {currentAddress.totalStaked.toFixed(2)} UNI
            </div>
            <div className="unilost">
              <b>UNI WITHDRAWN: </b>
              {currentAddress.totalWithdrawn.toFixed(2)} UNI
            </div>
            <div className="unilost">
              <b>UNI LOST: </b>
              {currentAddress.UNIlost.toFixed(2)} $(
              {(currentAddress.UNIlost * 26.77).toFixed(2)})
            </div>
            <div className="unilost">
              <b>NAPS CLAIMED: </b>
              {currentAddress.NAPSclaimed.toFixed(2)} NAP $ $(
              {(currentAddress.NAPSclaimed * 0.55).toFixed(0)})
            </div>
            <div className="unilost">
              <b>TOTAL USD LOST AFTER POOL REWARD: </b>$
              {(
                currentAddress.totalUSDLostForAccount *
                calcs.CLAIMED_NAP_REDUCE_MULTIPLIER
              ).toFixed(0)}
            </div>
            <div className="unilost">
              <b>TOTAL NAP COMPENSATION: </b>
              {(
                currentAddress.totalUSDLostForAccount *
                calcs.CLAIMED_NAP_REDUCE_MULTIPLIER
              ).toFixed(0) * 2}
            </div>
            <div className="unilost">
              <b>TOTAL WEIGHTED %: </b>
              {currentAddress.weightedPercent.toFixed(2)}
            </div>
          </div>
        ) : (
          <div>Could not find address</div>
        )}
        <h4>TOTAL USD LOST BEFORE POOL REWARDS: ${calcs.totalLostUSD}</h4>
        <h4>
          TOTAL LOST AFTER REMAINING NAP CLAIMS: $
          {calcs.TOTAL_USD_LOST_AFTER_CLAIMED_NAPS}
        </h4>
        <h4>
          TOTAL NAP COMP AFTER POOL REWARDS:{" "}
          {calcs.TOTAL_USD_LOST_AFTER_CLAIMED_NAPS * 2} NAP
        </h4>
      </header>
    </div>
  );
}

export default App;
